import { FC, memo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Dialog, DialogFace } from 'ui/components/Dialog'
import { Link } from 'ui/components/Link'
import { Table } from 'ui/components/Table'
import { StatusBadge } from '~bank-bsa-reporting/components/StatusBadge'

import { ItemInfo } from '../../types'
import { SARsInfoProps } from './SARsInfoProps'

export const SARsInfo: FC<SARsInfoProps> = memo((props) => {
  const { item, onClose } = props

  return item ? (
    <Dialog
      id={`batch-${item.id}`}
      onClose={onClose}
      face={DialogFace.PRIMARY}
      title={`Batch ID ${item.id}`}
      subTitle="SARs in the Batch"
      headerStyle={{ width: 800 }}
    >
      <Table<ItemInfo>
        dataQa={TableDataQa.BP_BATCH_SARS}
        columns={[
          {
            title: 'Name',
            align: 'left',
            render: (item) => (
              <Link to="/bsa/sars/$id" params={{ id: item.id.toString() }}>
                {item.name}
              </Link>
            )
          },
          {
            title: 'Status',
            align: 'left',
            render: ({ status }) => <StatusBadge status={status.toLocaleLowerCase()} />
          }
        ]}
        dataSource={item?.itemsInfo.map((el) => ({
          item: el
        }))}
      />
    </Dialog>
  ) : null
})
